import React from "react";
import logo from '../../../../src/assets/images2/header/Grupo 12@2x.png'
import {Link} from "react-router-dom";

interface Props {
    translator?: any;
}

export class FormSuccessScreen extends React.Component <Props> {

    translator: any;

    constructor(props: any) {
        super(props);

        window.scroll(0, 0);
    }

    initTranslator() {
    }

    render() {
        require('./FormSuccessScreen.scss');
        return (
            <div className="main-container">
                <div className="logo-container">
                    <img src={logo} alt="logo"/>
                </div>

                <div className="content-container">
                    <div className="content">
                        <h1 className="step-title">{this.props.translator("succesTitle")}</h1>
                        <p className="subtitle">{this.props.translator("successIndication")}</p>
                    </div>

                    <a href="https://mypopstoreapp.com/">
                        <button className="button">{this.props.translator("acceptModal")}</button>
                    </a>
                </div>
            </div>
        );
    }

}

export default FormSuccessScreen;